import {Injectable} from '@angular/core';
import {Mutation} from 'apollo-angular';
import gql from 'graphql-tag';

@Injectable({
  providedIn: 'root',
})
export class DeleteBarcodeMutation extends Mutation {
  document = gql`
      mutation deleteBarcodeItem($id: ID!) {
        deleteBarcodeItem(where: {id: $id}) {
              id
          }
      }
  `;
}
